import { Avatar, Box, CircularProgress, lighten, makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import { formatPercent } from '../../../../../logic/otherUtilities/formatting/formatPercent';

export interface CircleProps {
  share: number;
  progressColor: string;
  backgroundColor: string;
  labelColor: string;
}

export const useClasses = makeStyles((theme: Theme) => ({
  circle: {
    zIndex: 10,
    position: 'absolute',
    left: -37,
    top: 8,
  },
  bgCircle: {
    color: theme.palette.grey[200],
    zIndex: 9,
    position: 'absolute',
    left: -37,
    top: 8,
  },
  circleContainer: {
    position: 'relative',
    left: '50% ',
    height: 80,
    marginBottom: 20,
  },
  avatar: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    fontSize: 18,
    margin: 'auto',
    backgroundColor: lighten(theme.palette.primary.main, 0.1),
  },
  percent: {
    fontSize: 11,
    opacity: 0.8,
    marginTop: 4,
  },
  percentHidden: {
    fontSize: 11,
    opacity: 0,
    userSelect: 'none',
  },
}));

export const Circle: React.FC<CircleProps> = ({
  share,
  progressColor,
  backgroundColor,
  labelColor,
}) => {
  const classes = useClasses();
  return (
    <>
      <div className="text-center -mb-[75px] mt-4 pb-0.5">
        <Avatar className={classes.avatar} style={{ backgroundColor, color: labelColor }}>
          <span className={classes.percentHidden}>%</span>
          {formatPercent(share)}
          <span className={classes.percent}>%</span>
        </Avatar>
      </div>

      <div className={classes.circleContainer}>
        <CircularProgress
          size={74}
          thickness={5}
          value={share * 100}
          variant="determinate"
          className={classes.circle}
          style={{ color: progressColor }}
        />
        <CircularProgress
          size={74}
          thickness={5}
          value={100}
          variant="determinate"
          color="secondary"
          className={classes.bgCircle}
        />
      </div>
    </>
  );
};

export default Circle;
